<template>
  <div class="NewsShow">
    <div style="width: 980px;margin: auto;">

      <div style="text-align: right;">
        <el-button v-if="this.type != 3 " @click="startCheck()">提交审核</el-button>
      </div>

      <div v-if="this.type === 4" style="margin-left:100px;">
        <div style="line-height:30px; color:#ff0000;">审核建议:</div>
        <div style="line-height:30px; width:250px" word-wrap="break-word" v-html="advice"></div>
      </div>
      <div class="title-box" v-html="title"></div>

      <div>
        <div class="date-box1">{{this.companyName}} | 编辑：{{this.editor}} | 作者：{{this.author}}</div>
        <div class="date-box">发布时间：{{date}}</div>
      </div>

      <div v-html="content" class="details-box" v-if="this.isReprint==1"></div>
      <div class="details-box1" v-if="this.isReprint==2">{{this.content}}</div>
    </div>

  </div>
</template>

<script>
import time from "@/core/time";
import {ElLoading} from "element-plus";
export default {
  created() {
  },
  mounted() {
    this.id = this.$route.query.id;
    this.filter();
  },
  data(){
    return{
      isReprint:'',
      type:'',
      advice:'',
      id:null,
      date:'',
      content:'',
      title:'',
      companyName:'',
      editor:'',
      author:'',
      fileList:[],
    }
  },

  methods:{
    startCheck(){
      let data={
        id:this.id,
        type:2,
      }
      this.$request.post('/ArNews/startCheck',data).then(data=>{
        console.log("success!");
        this.$message({
          type: 'success',
          message: '已提交审核'
        })
      })
    },
    filter(){
      let data = {
        id:this.id,
      };
      let loadingInstance = null;
      loadingInstance = ElLoading.service({ fullscreen: true});
      this.$request.post('/ArNews/getNewsById',data).then(data => {
        console.log(data);
        this.companyName=data.obj.news.companyName;
        this.editor=data.obj.news.editor;
        this.author=data.obj.news.author;
        this.type=data.obj.news.type;
        this.advice=data.obj.news.advice;
        this.title =  data.obj.news.title;
        if(data.obj.news.isReprint==1){
          this.content = data.obj.news.content;
        }else{
          this.content = data.obj.news.content.replace(/<[^>]+>/g, "");
        }
        // this.content = data.obj.news.content;
        this.isReprint=data.obj.news.isReprint;
        this.date = time.formateDate(data.obj.news.createdDate);
        console.log("dizhi",this.content)
        loadingInstance.close();
      })
    },
  }
}
</script>

<style lang="less">
.NewsShow{
  width: 100%;
  height: 100%;
  a:link {color: black; text-decoration:none;} //未访问
  a:active {color: black; } //激活：红色
  a:visited {color:black;text-decoration:none;} //已访问
  a:hover {color: black; text-decoration:underline;} //鼠标移近
  .btn-back{
    border: none;
    font-size: 16px;
  }
  .title-box{
    text-align: center;
    font-size: 20px;
    margin: 50px 0 30px 0;
    font-weight: 800;
  }
  .date-box{
    font-size: 16px;
    color: #777777;
    text-align: right;
    padding-bottom: 48px;
    float: right;
  }
  .date-box1{
    font-size: 16px;
    color: #777777;
    text-align: left;
    padding-bottom: 48px;
    float: left;
  }

  .details-box{
    margin-top: 100px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;
    img{
      align:center;
      max-width: 100%;
      max-height: 700px;
    }


  }
  .details-box1{
    margin-top: 100px;
    font-size: 16px;
    line-height: 25px;
    text-align: left;

  }
  .file-box{
    margin-top: 40px;
    padding-bottom: 50px;
  }
}
</style>